<template>
  <div class="next-gen-article">
    <div class="next-gen-article__container" v-if="article">
      <div class="next-gen-article__title">
        <div class="next-gen-article__title--icon"
             :class="'type__' + article.content_type.id"
             v-if="article.content_type.id === 7">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
            <path fill="currentColor" d="M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z" transform="translate(-7.281 -7.281)"/>
          </svg>
        </div>
        <div class="next-gen-article__title--icon"
             :class="'type__' + article.content_type.id"
             v-else-if="article.content_type.id === 8">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.746" height="21.004" viewBox="0 0 15.746 21.004">
            <path fill="currentColor" d="M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z" transform="translate(-9.25 -6.996)"/>
          </svg>
        </div>
        <div class="next-gen-article__title--icon"
             :class="'type__' + article.content_type.id"
             v-else-if="article.content_type.id === 9">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.75" height="21" viewBox="0 0 15.75 21">
            <path fill="currentColor" d="M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z" transform="translate(-9.25 -7)"/>
          </svg>
        </div>
        <div class="next-gen-article__title--icon"
             :class="'type__' + article.content_type.id"
             v-else-if="article.content_type.id === 10">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.627" height="21" viewBox="0 0 23.627 21">
            <path fill="currentColor" d="M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z" transform="translate(-20213 8609.998)"/>
          </svg>
        </div>
        <div class="next-gen-article__title--icon"
             :class="'type__' + article.content_type.id"
             v-else-if="article.content_type.id === 11">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.53" height="22.876" viewBox="0 0 18.53 22.876">
            <g transform="translate(-8 -6.124)">
              <path fill="currentColor" d="M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z" transform="translate(0.517 1.307)"/>
              <path fill="currentColor" d="M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z" transform="translate(0.526 1.772)"/>
              <path fill="currentColor" d="M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"/>
              <path fill="currentColor" d="M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z" transform="translate(1.21 1.803)"/>
            </g>
          </svg>
        </div>
        <h1>{{ article.title }}</h1>
      </div>
      <div class="next-gen-article__sections">
        <div class="next-gen-article__section next-gen-article__content" role="main">
          <div class="task-content-media" v-if="(player.shown && player.url) || (imageFullPath !== '' && !player.shown)">
            <div class="task-content-video" v-if="player.shown && player.url">
              <iframe id="player"
                      frameborder="0"
                      webkitAllowFullScreen
                      mozallowfullscreen
                      allowFullScreen
                      height="340"
                      width="600"
                      :src="player.url"></iframe>
            </div>
            <div class="task-content-image"
                 :class="{'video-type': player.url}"
                 v-if="imageFullPath !== '' && !player.shown"
                 :title="article.alt"
                 v-bind:style="{backgroundImage: 'url(' + imageFullPath + ')'}">
              <div class="task-content-video-play"
                   @click="playVideo()"
                   v-if="player.url">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="play-circle"
                     class="svg-inline--fa fa-play-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor" d="M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1
                  16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200
                  200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="task-content-resources"
               v-if="article.content_type.id === 8 || article.content_type.id === 9">
            <div class="task-content-resources-items">
              <a href="#"
                 role="button"
                 @click.prevent="downloadFile(resource)"
                 target="_blank"
                 v-if="resource.file"
                 v-for="resource in article.resources">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-circle-down"
                     class="svg-inline--fa fa-arrow-circle-down fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor" d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288
               302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4
               9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"></path>
                </svg>
                <span>{{ resource.name ? resource.name : resource.file }}</span>
              </a>
            </div>
          </div>
          <div class="task-content-text"
               :inner-html.prop="article.content"></div>
          <div class="task-content-meta">
            <div v-if="article.categories && article.categories.length">
              <i class="fas fa-binoculars"></i>
              <div>
                <template v-for="(category, index) in article.categories">
                  <span v-if="index !== 0">, </span>
                  <router-link :to="{ name: 'knowledge-base', query: { categories: category.id } }">{{ category.title }}</router-link>
                </template>
              </div>
            </div>
            <div v-if="article.tags && article.tags.length">
              <i class="fas fa-tag"></i>
              <div>
                <template v-for="(tag, index) in article.tags">
                  <span v-if="index !== 0">, </span>
                  <router-link :to="{ name: 'knowledge-base', query: { topics: tag.id } }">{{ tag.name }}</router-link>
                </template>
              </div>
            </div>
          </div>
          <div class="task-content-related" v-if="relatedArticles && relatedArticles.length">
            <div class="task-content-related-header">
              Related resources
            </div>
            <ul class="task-content-related-list">
              <li class="task-content-related-item" v-for="item in relatedArticles">
                <router-link :to="{ 'name': 'content', 'params': { 'id': item.id } }">
                  <div class="task-content-related-icon" v-if="item.content_type">
                    <template v-if="item.content_type.id === 7">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                        <g>
                          <circle class="st0" cx="16" cy="16" r="16"/>
                            <path id="play" class="st1" d="M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329
                              c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55
                              c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719
                              c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719
                              c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16
                              c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004
                              c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027
                              C8.969,16.003,8.969,16.001,8.969,16z"/>
                        </g>
                      </svg>
                    </template>
                    <template v-else-if="item.content_type.id === 8">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                        <g>
                          <circle class="st0" cx="16" cy="16" r="16"/>
                            <path id="file-pdf" class="st1" d="M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17
                                c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687
                                V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656
                                c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265
                                c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969
                                c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359
                                c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1
                                c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792
                                c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23
                                C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z
                                 M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1
                                L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"/>
                        </g>
                      </svg>
                    </template>
                    <template v-else-if="item.content_type.id === 9">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                        <g>
                          <circle class="st0" cx="16" cy="16" r="16"/>
                            <path id="file-alt" class="st1" d="M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9
                                c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422
                                L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9
                                c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637
                                c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625
                                C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z
                                 M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"/>
                        </g>
                      </svg>
                    </template>
                    <template v-else-if="item.content_type.id === 10">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                        <g>
                          <circle class="st0" cx="16" cy="16" r="16"/>
                          <g>
                            <path class="st1" d="M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75
                                l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872
                                c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688
                                C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"/>
                            <path class="st1" d="M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1
                                C10.375,13.026,10.599,13.25,10.875,13.25z"/>
                            <path class="st1" d="M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1
                                C10.375,17.025,10.599,17.25,10.875,17.25z"/>
                          </g>
                        </g>
                      </svg>
                    </template>
                    <template v-else-if="item.content_type.id === 11">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                        <g>
                          <circle class="st0" cx="16" cy="16" r="16"/>
                          <g>
                            <path class="st1" d="M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514
                                c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421
                                C17.701,14.421,17.7,14.421,17.7,14.421z"/>
                            <path class="st1" d="M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8
                                C11.567,17.375,11.379,17.563,11.378,17.796z"/>
                            <path class="st1" d="M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62
                                c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5
                                h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z
                                 M17,7.949l2.675,2.675H17V7.949z"/>
                            <path class="st1" d="M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2
                                c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002
                                c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255
                                c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003
                                l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2
                                S20.355,23.124,19.25,23.124z"/>
                          </g>
                        </g>
                      </svg>
                    </template>
                  </div>
                  {{ item.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="next-gen-article__side" :class="{'equal-sections': isRegularUser}" role="complementary">
          <template v-if="isLightUser || isAdmin">
            <div class="next-gen-article__section next-gen-article__categories" v-if="articleCategories">
              <div class="next-gen-article__section--title">
                <i class="fas fa-sitemap"></i>
                <h2>Categories</h2>
              </div>
              <ul class="next-gen-article__categories--items">
                <li v-for="category in articleCategories"
                    :key="category.id">
                  <router-link class="next-gen-article__categories--item"
                               :to="{ name: 'knowledge-base', query: { categories: category.id } }">
                    <div class="next-gen-article__categories--item__icon"
                         v-if="category.icon"
                         v-html="category.icon"></div>
                    <span>{{ category.title }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="next-gen-article__section next-gen-article__topics" v-if="articleTopics">
              <div class="next-gen-article__section--title">
                <i class="fas fa-tag"></i>
                <h2>Topics</h2>
              </div>
              <div class="next-gen-article__topics--items">
                <router-link class="next-gen-article__topics--item"
                             v-for="topic in articleTopics"
                             :key="topic.id"
                             :to="{ name: 'knowledge-base', query: { topics: topic.id } }">
                  <div class="next-gen-article__topics--item__icon"
                       v-if="topic.icon"
                       v-html="topic.icon"></div>
                  <span>{{ topic.title }}</span>
                </router-link>
              </div>
            </div>
          </template>
          <template v-if="isRegularUser">
            <div class="next-gen-article__section next-gen-article__tasks" v-if="relatedTasks && relatedTasks.length">
              <div class="next-gen-article__section--title">
                <i class="fas fa-link"></i>
                <h2>Related tasks</h2>
              </div>
              <div class="next-gen-article__tasks--items">
                <router-link :to="{name: 'task', params: {id: task.id}}"
                             :key="task.id"
                             v-bind:aria-label="task.title"
                             class="next-gen-article__tasks--item"
                             v-for="task in relatedTasks">
                  <div class="next-gen-article__tasks--item-data">
                    <span class="next-gen-article__tasks--item-key" :class="{ 'line-through': task.status && task.status.id === 4 }">
                      {{ task.key }}
                    </span>
                    <span class="next-gen-article__tasks--item-name">
                      {{ task.title }}
                    </span>
                  </div>
                  <div class="next-gen-article__tasks--item-meta">
                    <div class="next-gen-article__tasks--item-chapter" :class="{ empty: !task.chapter }">
                      <template v-if="task.chapter">
                        <div class="next-gen-article__tasks--item-chapter-progress">
                          <div class="next-gen-article__tasks--item-chapter-image"
                               v-bind:style="{ backgroundImage: getChapterBackground(task.chapter) }"></div>
                          <svg class="progress" width="130" height="130" viewBox="0 0 100 100">
                            <circle class="progress_meter" cx="50" cy="50" r="44" stroke-width="5"/>
                            <circle class="progress_value"
                                    :class="'filters_progress_value-' + task.chapter.id"
                                    cx="50" cy="50" r="44"
                                    stroke-width="5"/>
                          </svg>
                        </div>
                        <div class="next-gen-article__tasks--item-chapter-name">{{ task.chapter.name }}</div>
                      </template>
                    </div>
                    <div class="next-gen-article__tasks--item-meta-user-info">
                      <div class="next-gen-article__tasks--item-meta-properties">
                        <div class="next-gen-article__tasks--item-meta-property recurrency" v-if="task.recurrent">
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sync-alt"
                               class="svg-inline--fa fa-sync-alt fa-w-16"
                               role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 512 512">
                            <path fill="currentColor" d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328
                            53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933
                            94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504
                            57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382
                            0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144
                            162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187
                            504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"></path>
                          </svg>
                        </div>
                        <div class="next-gen-article__tasks--item-meta-property mandatory" v-if="task.mandatory">
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle"
                               class="svg-inline--fa fa-exclamation-circle fa-w-16"
                               role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248
                            111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418
                            136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884
                            0-12.356 5.78-11.981 12.654z"></path>
                          </svg>
                        </div>
                      </div>
                      <div class="next-gen-article__tasks--item-meta-user priority"
                           v-bind:class="['priority-' + taskPriorityDelta(task.score)]">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up"
                             class="svg-inline--fa fa-arrow-up fa-w-14" role="img"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6
                                                0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path>
                        </svg>
                        <span>{{ taskPriorityLabelByValue(taskPriorityDelta(task.score)) }}</span>
                      </div>
                      <div class="next-gen-article__tasks--item-meta-user status"
                           v-if="task.status"
                           v-bind:class="['status-' + task.status.id]">
                        <template v-if="task.status.id === 1">
                          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="dot-circle"
                               class="svg-inline--fa fa-dot-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200
                                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0
                                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"></path>
                          </svg>
                        </template>
                        <template v-else-if="task.status.id === 2">
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner"
                               class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 512 512">
                            <path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48
                                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49
                                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49
                                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156
                                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48
                                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                          </svg>
                        </template>
                        <template v-else-if="task.status.id === 3">
                          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="eye"
                               class="svg-inline--fa fa-eye fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 576 512">
                            <path fill="currentColor" d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4
                                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48
                                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0
                                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path>
                          </svg>
                        </template>
                        <template v-else-if="task.status.id === 4">
                          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                               class="svg-inline--fa fa-check-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8
                                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532
                                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346
                                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068
                                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path>
                          </svg>
                        </template>
                        <span class="status-text">{{ task.status.name }}</span>
                      </div>
                      <div class="next-gen-article__tasks--item-meta-user user-avatar">
                        <template v-if="task.assignee">
                          <span v-if="task.assignee.image" v-bind:style="{ backgroundImage: 'url(\'' + imageBase + task.assignee.image + '\')' }"></span>
                          <avatar v-else :username="task.assignee.name" :size="32" color="#ffffff"></avatar>
                        </template>
                        <template v-else>
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle"
                               class="svg-inline--fa fa-user-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 496 512">
                            <path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0
                                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4
                                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1
                                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"></path>
                          </svg>
                        </template>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import api from '@/api'
  import Avatar from 'vue-avatar'

  export default {
    name: 'next-gen-article',
    data () {
      return {
        articleId: null,
        relatedArticles: [],
        relatedTasks: [],
        article: null,
        children: [],
        player: {
          shown: false,
          url: '',
          options: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'isAdmin',
        'isRegularUser',
        'isLightUser',
        'getUserCompany',
        'articleCategories',
        'articleTopics',
        'tasksPriorities'
      ]),
      imageFullPath () {
        return this.article.image_name ? api.serverContenImages + this.article.image_name : ''
      },
      imageBase () {
        return api.serverUserImages
      }
    },
    components: {
      Avatar
    },
    methods: {
      ...mapActions([
        'getCategories',
        'getTags'
      ]),
      getArticleById () {
        this.article = null
        this.$http.get(api.URLS.contentNew + '/' + this.articleId, api.headersAuthSettings).then((res) => {
          if (!res.body.is_article) {
            this.redirectTask()
            return
          }
          this.article = res.body
          this.getArticleRelatedById()
          this.setupPageMeta()
          this.maybeVideoTypeArticle()
          this.setupExternalLinkClicks()
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'no-permissions'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      getArticleRelatedById () {
        this.$http.get(api.URLS.contentNew + '/related/' + this.articleId, api.headersAuthSettings).then((res) => {
          this.children = res.body
          this.setupRelated()
        }).catch((err) => {
          console.log(err)
        })
      },
      redirectTask () {
        if (this.isAdmin) {
          this.$router.push({
            name: 'company-task',
            params: {
              companyId: 2,
              id: this.articleId
            }
          })
        } else {
          this.$router.push({name: 'task', params: {id: this.articleId}})
        }
      },
      setupPageMeta () {
        document.title = this.article.title + ' | Clear Assured'
        this.$store.commit('setUserDimensions')
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['setCustomDimension', 8, 'article'])
          window._paq.push(['setCustomDimension', 9, this.article.content_type.type ? this.article.content_type.type.replace(/\s/g, '') : null])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ARTICLE')
        //   window.ga('set', 'contentGroup2', this.article.content_type.type ? this.article.content_type.type.replace(/\s/g, '') : null)
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      },
      setupRelated () {
        this.relatedArticles = this.children.filter((item) => item.is_article)
        if (this.isRegularUser) {
          const relatedTasks = this.children.filter((item) => !item.is_article)
          this.getTasks(relatedTasks)
        }
      },
      getTasks (relatedTasks) {
        if (!relatedTasks || !relatedTasks.length) {
          return
        }
        const tasksIds = relatedTasks.map(t => t.id)
        const data = {
          list: tasksIds
        }
        this.$http.put(`${api.URLS.task}/ids`, data, api.headersAuthSettings).then((res) => {
          this.relatedTasks = res.body.tasks
        }).catch((error) => {
          console.log(error)
        })
      },
      maybeVideoTypeArticle () {
        if (this.article.content_type.type === 'Video' && this.article.resources !== null) {
          let resources = this.article.resources
          let poster = this.article.image_name !== null
          this.player.url = resources[0].link !== '' ? resources[0].link : null
          if (!poster) {
            this.initPlayer(false)
          }
        } else {
          this.player = {
            shown: false,
            url: '',
            options: ''
          }
        }
      },
      initPlayer (autoPlay) {
        let newVideoUrl = this.getVideoUrl(this.player.url)
        if (autoPlay) {
          newVideoUrl += '?autoplay=1&loop=1'
        }
        this.player.url = newVideoUrl
        this.player.shown = true
      },
      getVideoUrl (url) {
        if (!url) {
          return
        }
        let linkPart = url.split('/')
        let link
        let id
        if (linkPart[2].indexOf('youtu') !== -1) {
          id = this.youtubeParser(url)
          if (!id) {
            return
          }
          link = `${linkPart[0]}//www.youtube.com/embed/${id}`
        }
        if (linkPart[2].indexOf('vimeo') !== -1) {
          id = this.vimeoParser(url)
          if (!id) {
            return
          }
          link = `${linkPart[0]}//player.vimeo.com/video/${id}`
        }
        return link
      },
      youtubeParser (url) {
        let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        let match = url.match(regExp)
        return (match && match[7].length === 11) ? match[7] : false
      },
      vimeoParser (url) {
        let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
        let match = url.match(regExp)
        return match[5] || false
      },
      setupExternalLinkClicks () {
        setTimeout(() => {
          Array.from(document.querySelectorAll('a')).forEach(a => {
            if (location.hostname !== a.hostname) {
              a.addEventListener('click', function () {
                if (window._paq) {
                  window._paq.push(['trackEvent', 'ExternalUrl', 'Click', a.href])
                }
                // if (window.ga) {
                //   window.ga('send', {
                //     hitType: 'event',
                //     eventCategory: 'ExternalUrl',
                //     eventAction: 'Click',
                //     eventLabel: a.href,
                //     eventValue: 1
                //   })
                // }
              })
            }
          })
        }, 1500)
      },
      playVideo () {
        this.initPlayer(true)
        if (window._paq) {
          window._paq.push(['trackEvent', 'VIDEO', 'Play', this.taskTitle])
        }
        // if (window.ga) {
        //   window.ga('send', {
        //     hitType: 'event',
        //     eventCategory: 'VIDEO',
        //     eventAction: 'Play',
        //     eventLabel: this.taskTitle,
        //     eventValue: 1,
        //     page: location.pathname,
        //     location: location.href
        //   })
        // }
      },
      downloadFile (file) {
        this.gaDownloadEvent(file)
        let actionURL = `${api.URLS.content}/download-file`
        if (this.getUserCompany) {
          actionURL += `?company=${this.getUserCompany}`
        }
        let fileName = file.name || file.file
        let data = {
          type: 'content',
          content: this.articleId,
          file: file.file
        }
        let options = {
          ...api.headersAuthSettings,
          responseType: 'blob'
        }
        this.$http.post(actionURL, data, options).then((res) => {
          let data = new Blob([res['data']])
          if (window.navigator.msSaveBlob) {
            navigator.msSaveBlob(data, fileName)
          } else {
            const dataUrl = URL.createObjectURL(data)
            const link = document.createElement('A')
            link.setAttribute('href', dataUrl)
            link.setAttribute('download', fileName)
            link.click()
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      gaDownloadEvent (file) {
        let name = file.name || file.file
        if (window._paq) {
          window._paq.push(['trackEvent', 'FILE', 'Download', name])
        }
        // if (window.ga) {
        //   window.ga('send', {
        //     hitType: 'event',
        //     eventCategory: 'FILE',
        //     eventAction: 'Download',
        //     eventLabel: name,
        //     page: location.pathname,
        //     location: location.href
        //   })
        // }
      },
      getChapterBackground (chapter) {
        if (this.selectedHightCont === 1) {
          return 'url(' + chapter.image_high + ')'
        } else {
          return 'url(' + chapter.image + ')'
        }
      },
      taskPriorityDelta (value) {
        let priorityDelta = 0
        if (value <= 33) {
          priorityDelta = 0
        } else if (value > 33 && value <= 66) {
          priorityDelta = 1
        } else if (value > 66 && value <= 100) {
          priorityDelta = 2
        }
        return priorityDelta
      },
      taskPriorityLabelByValue (value) {
        const priority = this.tasksPriorities.find((item) => item.value === value)
        return priority ? priority.label : ''
      }
    },
    created () {
      this.articleId = this.$route.params.id
    },
    mounted () {
      this.getArticleById()
      if (this.isLightUser || this.isAdmin) {
        this.getCategories()
        this.getTags()
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id) {
          this.articleId = to.params.id
          this.getArticleById()
        }
      }
    },
    beforeUnmount () {
      if (window._paq) {
        window._paq.push(['deleteCustomDimension', 8])
        window._paq.push(['deleteCustomDimension', 9])
      }
    }
  }
</script>

<style src="@/assets/scss/components/tasks/task-content.scss" lang="scss" scoped />
<style src="@/assets/scss/components/next-gen-article.scss" lang="scss" scoped />
<style src="@/assets/fonts/font-awesome/css/all.css" lang="css" />



// WEBPACK FOOTER //
// NextGenArticle.vue?4952a170